module.exports = __webpack_public_path__ + "static/media/logo.2c5fcc09.png";